import { Outlet } from 'react-router'

import { Button } from '@/components/ui/button'
import { AppVersion } from '@/components/version'
import { useAuthLogoutDialog } from '@/stores'

export function CompaniesLayout() {
  const { onOpenChange } = useAuthLogoutDialog()

  return (
    <div className="relative flex min-h-screen select-none items-center justify-center bg-cover bg-center bg-no-repeat antialiased">
      <div className="absolute inset-0 z-0 overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          poster="/videos/backgrounds/login/background.jpg"
          className="h-full w-full object-cover"
        >
          <source
            src="/videos/backgrounds/login/background.mp4"
            type="video/mp4"
          />
        </video>
      </div>

      <img
        src="/images/logos/fintalk.svg"
        alt="Fintalk logo"
        width={140}
        className="hidden md:absolute md:left-8 md:top-8 md:block md:object-cover"
      />

      <Button
        variant="outline"
        className="hidden md:absolute md:right-10 md:top-10 md:block"
        onClick={() => onOpenChange(true)}
      >
        Logout
      </Button>
      <Button
        variant="outline"
        size="sm"
        className="absolute right-4 top-4 md:hidden"
        onClick={() => onOpenChange(true)}
      >
        Logout
      </Button>

      <div className="z-10">
        <Outlet />
      </div>

      <div className="absolute bottom-4 left-1/2 z-10 -translate-x-1/2">
        <AppVersion />
      </div>
    </div>
  )
}
